import { validateSingleLineQuestion } from 'components/SignupFormQuestions/SingleLineQuestion'
import { validateYearQuestion } from 'components/SignupFormQuestions/YearQuestion'
import { validateRegionQuestion } from 'components/SignupFormQuestions/RegionQuestion'
import { validateCheckboxQuestion } from 'components/SignupFormQuestions/CheckboxQuestion'
import { validateDropdownQuestion } from 'components/SignupFormQuestions/DropdownQuestion'
import { validateEssayQuestion } from 'components/SignupFormQuestions/EssayQuestion'
import { validateRadioButtonQuestion } from 'components/SignupFormQuestions/RadioButtonQuestion'
import { validateNumberQuestion } from 'components/SignupFormQuestions/NumberQuestion'
import { validateDateQuestion } from 'components/SignupFormQuestions/DateQuestion'
import { validateEmailQuestion } from 'components/SignupFormQuestions/EmailQuestion'
import { validateAccountEmailQuestion } from 'components/SignupFormQuestions/AccountEmailQuestion'
import { validateLoginQuestion } from 'components/SignupFormQuestions/LoginQuestion'

type ValidateFunction = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  answer: IndexType,
  question: Partial<any>,
) => Promise<string[]>

export const validateQuestion: ValidateFunction = (answer, question) => {
  const Validation: {
    [key in any]: any
  } = {
    // Section & Image questions have no answers,
    // so just return empty promises indicating no validation erros
    ImageQuestion: async () => [],
    SectionQuestion: async () => [],
    SingleLineQuestion: validateSingleLineQuestion,
    DateQuestion: question.yearOnlyDate
      ? validateYearQuestion
      : validateDateQuestion,
    EmailQuestion: validateEmailQuestion,
    EssayQuestion: validateEssayQuestion,
    NumberQuestion: validateNumberQuestion,
    RegionQuestion: validateRegionQuestion,
    CheckBoxQuestion: validateCheckboxQuestion,
    DropDownQuestion: validateDropdownQuestion,
    RadioButtonQuestion: validateRadioButtonQuestion,
    'SignupForm::AccountEmailQuestion': validateAccountEmailQuestion,
    'SignupForm::LoginQuestion': validateLoginQuestion,
    'SignupForm::TosQuestion': async () => [],
    'SignupForm::PasswordQuestion': async () => [],
    EmailOrScreenNameQuestion: async () => [],
    LoginPasswordQuestion: async () => [],
    'Demographics::LocationQuestion': async () => [],
    'Demographics::AgeQuestion': async () => [],
  }

  return Validation[question.type].call(undefined, answer, question)
}
